import axios from '@/utils/axiosReq'
import URL from './urlConstants'
class RemindFetch {
  // 权限校验接口
  getRemindInfor () {
    return axios.get(URL.REMIND.SELLER_REMIND)
  }
  saveRemind (params) {
    return axios.post(URL.REMIND.SAVE_REMIND, params)
  }
  getMessageList (params) {
    return axios.get(URL.REMIND.MESSAGE_LIST, params)
  }
  readAllMessage () {
    return axios.post(URL.REMIND.READ_ALL_MESSAGE)
  }
  readMessage (params) {
    return axios.post(URL.REMIND.READ_MESSAGE, params)
  }
  getUnReadMsgCount () {
    return axios.get(URL.REMIND.UNREAD_COUNT)
  }
}
const remindFetch = new RemindFetch()
export default remindFetch
